import BackButton from '@/components/Buttons/BackButton';
import DynamicPage from '@/components/DynamicPage/DynamicPage';
import PAGE_IDS from '@/consts/pageIds';
import useHideMenu from '@/hooks/useHideMenu';
import appRouterService from '@/services/route/appRouterService';

const RewardsPage = ({isActive}: {isActive: boolean}) => {
    useHideMenu(isActive);

    return (
        <div className='flex h-full min-h-0 flex-col pt-app-4 pb-app-4'>
            <BackButton onClick={appRouterService.goBack} className='ml-4 shrink-0' />
            <DynamicPage pageId={PAGE_IDS.REWARDS} className='min-h-0 flex-1' />
        </div>
    );
};

export default RewardsPage;
